import { useIntentBehavior } from 'seagull';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { Intent } from '~/infra/access-control';
export const useBulkCreateDraftsEntry = ()=>{
    const { BULK_CREATE_PROPOSALS } = useFeatureFlags();
    const { getDisabled } = useIntentBehavior();
    return {
        isOffered: !!BULK_CREATE_PROPOSALS && !getDisabled(Intent.BulkCreateDrafts)
    };
};
